import { IonActionSheet, IonItem, IonLabel, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { albums, print, cloudDone, copy, download, duplicate, enter, exit, folder, heart, image, link, lockClosed, notifications, pricetag, pricetags, school, search, star, statsChart, text, trash, volumeHigh, barChart, barbell, ellipsisHorizontalCircleSharp } from 'ionicons/icons';
import React from 'react';
import '../styles/HelpGuides.scss';
import Utilities from '../Utilities';
import ContactUs from './ContactUs';
import { ArrowComponent } from './HelpOverlay';

class HelpGuides extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
        section: "",
        contactUsSheet: null
      }
  }

  async componentDidMount() {
    Utilities.trackEvent("Help Guides", "Help Guides Page View");
    this.setState({ section: this.props.match.params.slug })
    setTimeout(function() { if (this.grid3) this.grid3.updateLayout(); }.bind(this), 200)
    setTimeout(function() { if (this.grid3) this.grid3.updateLayout(); }.bind(this), 400)
    setTimeout(function() { if (this.grid3) this.grid3.updateLayout(); }.bind(this), 1000)
  }

  render() {
    return (
      <IonPage data-page="help-guides">
        <IonHeader>
          <IonToolbar>
            <IonTitle>Help Guides</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent id="help-guides-wrapper" fullscreen>
          <div id="help-guides">
            <ContactUs />
            <div className="guides">
              { [
                // { label: "Creating Studysets", icon: folder, slug: "" },
                // { label: "Creating Flashcards", icon: duplicate, slug: "" },
                // { label: "Study with quizes (multi-select, spell, translate)", icon: school, slug: "" },
                // { label: "Study with Notifications", icon: notifications, slug: "" },
                // { label: "Study in Flashcard View", icon: albums, slug: "" },
                { label: window.ln.guideSpacedRepetition, icon: barChart, slug: "spaced-repetition" },
                { label: window.ln.guideSearch, icon: search, slug: "search" },
                // { label: "Tags Management", icon: pricetags, slug: "" },
                // { label: "Mark flashcards as Favorite", icon: star, slug: "" },
                // { label: "Add custom text fields for flashcards", icon: text, slug: "" },
                // { label: "Add links to related flashcards", icon: link, slug: "" },
                // { label: "Add images", icon: image, slug: "" },
                { id: "sync", label: window.ln.guideSync, icon: cloudDone, onClick: () => { window.startDropboxAuth(); }},
                // { label: "Statistics", icon: statsChart, slug: "" },
                { label: window.ln.guideImport, icon: enter, slug: "import" },
                // { label: "Exporting cards into an machine-readable format", icon: exit, slug: "" },
                // { label: "Print cards for offline learning", icon: print, slug: "" },
                // { label: "Deleting and Archiving", icon: trash, slug: "" },
                { label: window.ln.guidePronunciation, icon: volumeHigh, slug: "pronunciation" },
                { label: window.ln.guideAccess + " " +  window.ln.guideData, icon: lockClosed, slug: "security" },
                { label: window.ln.guideContact, icon: ellipsisHorizontalCircleSharp, onClick: () => { this.setState({ contactUsSheet: true }) } },
              ].map(item => {
                  if (item.id === "sync" && window.settings2 && window.settings2.dropbox)
                    return null;
                  return (
                    <IonItem 
                      onClick={() => { 
                        if (item.slug) {
                          this.props.history.push("/help/" + item.slug)
                        } else {
                          item.onClick();
                        }
                      }}>
                      <IonLabel className="ion-text-wrap">
                        <h3>{item.label}</h3>
                      </IonLabel>
                      <IonIcon icon={item.icon} slot="start" />
                    </IonItem>
                  )
              })

              }

              <IonActionSheet
                  isOpen={this.state.contactUsSheet}
                  onDidDismiss={() => { this.setState({ contactUsSheet: false }) }}
                  buttons={[
                      { text: "WhatsApp", handler: () => {
                        Utilities.trackEvent("Contact", "Contact by WhatsApp", "Help Guides")
                        window.open("https://wa.me/36705359591?text=[App:FMS]")}
                      },
                      { text: "Email", handler: () => {
                        Utilities.trackEvent("Contact", "Contact by Email", "Help Guides")
                        window.open("mailto:hello@chillnstudy.com?subject=[App:FMS]")}
                      },
                  ]}
              />

            </div>
            
          </div>
        </IonContent>
      </IonPage>
    );
  }

};

export default HelpGuides;
